/**************************************************
 * Nombre:       Dona_Limpia
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {COLORES} from "../ContantesColorGraficas";
import Mapa from "./Componentes/Mapa/Mapa";

const Mapa_Departamentos = ({ancho, labels = [], series = [], marginTop = 0, height = 'auto'}) => {
    const options = {
        chart: {
            id: "area-bar",
            sparkline: {
                enabled: true,
            },
        },
        labels: labels,
        stroke: {
            width: 2,
            curve: 'smooth'
        },
        colors: COLORES,


    }


    return (
        <Mapa series={series}/>
    )

}
export default Mapa_Departamentos